<template>
  <page-layout :title="categoryData.categoryNm">
    <template v-slot:content>
      <v-container class="board-write-container">
        <div class="board-write-layout">
          <div class="board-write-title">
            <span class="text-h4">수정하기</span>
          </div>
          <div class="board-write-content-layout">
            <div class="board-notice-level">
              <v-select
                  v-model="modifyData.noticeLevel"
                  :items="noticeLevelList"
                  item-text="text"
                  item-value="value"
                  placeholder="카테고리를 선택해주세요"
                  outlined hide-details dense
                  background-color="white"
              />
            </div>
            <div v-if="isAdmin">
              <v-row>
                <v-col class="col-xl-2 col-lg-2 col-md-2 col-sm-4">
                  <v-checkbox
                      label="팝업공지여부"
                      v-model="popupYn"
                      @change="changePopupYn"
                  />
                </v-col>
                <v-col v-if="popupYn" class="d-flex justify-center align-center col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
                  <single-date-input
                    :start-date="modifyData.popupStDt"
                    @updateDate="updateStartDate"
                  />
                  <span style="margin: 0 5px">~</span>
                  <single-date-input
                    :start-date="modifyData.popupEdDt"
                    @updateDate="updateEndDate"
                  />
                </v-col>
              </v-row>
            </div>
            <div class="board-write-title">
              <v-text-field
                  v-model="modifyData.title"
                  placeholder="제목을 입력해주세요"
                  outlined hide-details
                  background-color="white"
              />
            </div>
            <div class="board-write-content">
              <v-textarea
                  v-model="modifyData.content"
                  placeholder="내용을 입력해주세요"
                  outlined hide-details auto-grow
                  rows="4" row-height="100"
              />
            </div>
            <div class="file-input-layout">
              <div class="existing-files-label mr-2">
                <span class="font-weight-medium">기존 첨부 파일</span>
              </div>
              <div class="existing-files-chips">
                <template v-for="(file, idx) in existingFiles">
                  <v-chip
                    v-if="file.delYn !== 'Y'"
                    :key="file.fileKey"
                    small
                    class="mr-2"
                    text-color="white"
                    color="#455a64"
                    close
                    @click:close="removeExistingFile(idx)"
                  >
                    {{ file.fileNm }}.{{ file.fileType }}
                  </v-chip>
                </template>
              </div>
            </div>

            <!-- 2) 신규 파일 선택 (newFiles) -->
            <div class="file-input-layout mt-4">
              <v-file-input
                  v-model="newFiles"
                  accept=".jpg, .jpeg, .png, .pdf, .zip, .xlsx, .ppt, .pptx, .docx, .hwp, .hwpx"
                  small-chips show-size multiple clearable outlined
                  prepend-icon="" prepend-inner-icon="mdi-paperclip"
                  placeholder="새로운 파일을 첨부해주세요."
                  @change="fileUpload"
              >
                <template v-slot:selection="{ text, index }">
                  <!-- newFiles 배열에 있는 파일명만 보여주고, 삭제 시 removeNewFile 호출 -->
                  <v-chip
                      small
                      text-color="white"
                      color="#00796b"
                      close
                      @click:close="removeNewFile(index)"
                  >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
            </div>

            <!-- 1차 오픈 제외 추후 반영 -->
            <!-- 3) 이미지 미리보기 영역 -->
<!--            <v-row class="mt-4" dense>-->
<!--              <template v-for="(src, idx) in previews">-->
<!--                <v-col v-if="src" :key="`preview-${idx}`" cols="6" sm="4" md="3">-->
<!--                  <v-card outlined elevation="1">-->
<!--                    <v-img :src="src" aspect-ratio="1" class="image-preview" />-->
<!--                  </v-card>-->
<!--                </v-col>-->
<!--              </template>-->
<!--            </v-row>-->
          </div>
          <div class="buttons-layout">
            <v-btn class="button save" outlined @click="saveBoard">수정하기</v-btn>
            <v-btn class="button delete" outlined @click="previousPage">취소</v-btn>
          </div>
        </div>
      </v-container>
    </template>
  </page-layout>
</template>
<script>
import PageLayout from "@/common/layout/PageLayout.vue";
import constant from "@/util/constant";
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";
import router from "@/router";
import {mapGetters} from "vuex";
import SingleDateInput from "@/common/components/input/SingleDateInput.vue";
import DateMixin from "@/mixin/DateMixin";

export default {
  name: "BoardModify",
  components: {SingleDateInput, PageLayout},
  mixins: [DateMixin],
  data() {
    return {
      categoryData: {},
      modifyData: {},     // 게시물 정보 수정 데이터
      popupYn: false,
      existingFiles: [],  // 기존 파일 정보
      newFiles: [],       // 신규 파일 정보
      previews: [],       // 이미지 미리보기 URL
      base64Files: []     // 최종 파일 데이터
    }
  },
  computed: {
    ...mapGetters("login", {
      memberId: "memberId",
      isAdmin: "isAdmin",
      memberRole: "memberRole"
    }),
    noticeLevelList() {
      if (this.memberRole === "MANAGER") {
        return constant.NOTICE_LEVEL_LIST.filter(item => item.value === 1);
      }
      return constant.NOTICE_LEVEL_LIST;
    }
  },
  async mounted() {
    // 카테고리 데이터
    this.categoryData = JSON.parse(sessionStorage.getItem("boardDetailList"));
    // 세션에서 게시물 데이터 가져오기
    const boardInfo = JSON.parse(sessionStorage.getItem("boardDetail"));
    // 게시물 ID로 게시물 상세 조회
    const { data } = await axiosInstance.get("/private/board/board", {
      params: {
        boardId: boardInfo.boardId
      }
    });
    if (data) {
      this.modifyData = _.cloneDeep(data.board);
      if (!this.modifyData.popupStDt || !this.modifyData.popupEdDt) {
        this.setDefaultDate();
      } else {
        this.modifyData.popupStDt = this.setDashDate(this.modifyData.popupStDt);
        this.modifyData.popupEdDt = this.setDashDate(this.modifyData.popupEdDt);
      }
      this.setPopupYnData(data.board);
      await this.initExistingFiles(data.files);
    }
  },
  methods: {
    // 기존 파일 처리
    async initExistingFiles(files) {
      const imageTypes = ["png", "jpg", "jpeg"];

      this.existingFiles = files.map(file => ({
        fileKey: file.fileKey,
        fileNm: file.fileNm,
        fileType: file.fileType,
        delYn: "N"
      }));

      for (const file of this.existingFiles) {
        if (imageTypes.includes(file.fileType)) {
          await this.blobImagePreview(file.fileKey);
        } else {
          this.previews.push("");
        }
      }
    },
    // fileKey 조회 데이터 BlobUrl 형태로 미리보기 생성
    async blobImagePreview(fileKey) {
      try {
        const response = await axiosInstance.get("/private/board/board-file", {
          responseType: 'blob',
          params: {
            fileKey: fileKey
          }
        });
        const blobUrl = URL.createObjectURL(response.data);
        this.previews.push(blobUrl);
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    async fileUpload(files) {
      this.newFiles = files;

      for (const file of files) {
        const base64String = await this.getFileBase64(file);
        const fileNm = file.name.replace(/\.[^/.]+$/, "");
        let fileType = file.type.split("/")[1];
        const excelType = "vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const wordType = "vnd.openxmlformats-officedocument.wordprocessingml.document";
        const pptType = "vnd.openxmlformats-officedocument.presentationml.presentation";
        if (fileType === excelType) {
          fileType = "xlsx";
        }
        if (fileType === wordType) {
          fileType = "docx";
        }
        if (fileType === pptType) {
          fileType = "pptx";
        }
        if (
            file.type === "" ||
            fileType === "haansofthwp"
        ) {
          fileType = "hwp";
        }
        if (fileType === "x-zip-compressed") {
          fileType = "zip";
        }

        this.base64Files.push({
          fileNm: fileNm,
          fileType: fileType,
          fileStr: base64String
        });
      }
    },
    // file 객체 Base64 데이터 url 로 변환
    getFileBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    removeExistingFile(index) {
      this.$set(this.existingFiles[index], "delYn", "Y");
    },
    removeNewFile(newIndex) {
      const removedFile = this.newFiles.splice(newIndex, 1)[0];

      const base64Index = this.base64Files.findIndex(item =>
          `${item.fileNm}.${item.fileType}` === removedFile.name
      );
      if (base64Index !== -1) {
        this.base64Files.splice(base64Index, 1);
      }
    },
    saveBoard() {
      if (
          this.modifyData.noticeLevel === undefined ||
          _.isEmpty(this.modifyData.title) ||
          _.isEmpty(this.modifyData.content)
      ) {
        this.showAlert({message: "작성내용을 다시한번 확인해주세요"});
        return false;
      }

      this.showConfirm({
        message: "수정된 게시물을 저장하시겠습니까?",
        successCallback: () => {
          this.save();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    async save() {
      const boardInfo = {
        board: this.modifyData,
        files: [...this.existingFiles, ...this.base64Files]
      };
      boardInfo.board["updateId"] = this.memberId;
      boardInfo.board["categoryId"] = this.categoryData.categoryId;
      boardInfo.board["popupYn"] = this.popupYn ? "Y" : "N";
      boardInfo.board["popupStDt"] = boardInfo.board["popupStDt"].replaceAll("-", "");
      boardInfo.board["popupEdDt"] = boardInfo.board["popupEdDt"].replaceAll("-", "");

      try {
        await axiosInstance.patch("/private/board/board", boardInfo)
            .then(() => {
              this.showAlert({
                message: "수정이 완료되었습니다.",
                successCallback: () => {
                  router.push({name: "BoardDetail", params: {boardId: this.modifyData.boardId}});
                }
              })
            })
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    previousPage() {
      this.showConfirm({
        message: "이전 페이지로 이동 시 작성하던 데이터는 삭제됩니다. 이동하시겠습니까?",
        successCallback: () => {
          this.goBack();
        },
        failCallback: () => {
          return false;
        }
      })
    },
    goBack() {
      this.$router.go(-1);
    },
    changePopupYn(value) {
      if (value) {
        if (!this.modifyData.popupStDt || !this.modifyData.popupEdDt) {
          this.setDefaultDate();
        }
      }
    },
    setPopupYnData(data) {
      this.popupYn = data.popupYn === "Y";
    },
    setDefaultDate() {
      const {fromDate, toDate} = this.setDateDiff(14);
      this.modifyData.popupStDt = fromDate;
      this.modifyData.popupEdDt = toDate;
    },
    updateStartDate(value) {
      this.modifyData.popupStDt = value;
    },
    updateEndDate(value) {
      this.modifyData.popupEdDt = value;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/Board/BoardWrite.scss";
</style>